"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const Tooltip_1 = __importDefault(require("../../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../../enums/TooltipPosition"));
const MachineStore_1 = __importDefault(require("../../stores/MachineStore"));
class ShopProductMachineSelection extends react_1.default.Component {
    componentDidMount() {
        MachineStore_1.default.readMassiveMachines();
    }
    render() {
        if (MachineStore_1.default.isLoading) {
            return (react_1.default.createElement("div", { className: "znd-shop-product-page__machine-selection mb-5" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        if ((MachineStore_1.default.cutters?.length ?? 0) <= 0) {
            return (react_1.default.createElement("div", { className: "znd-shop-product-page__machine-selection mb-5" },
                react_1.default.createElement("div", { className: "font-weight-bold text-danger" }, (0, translation_1.t)('product_page.machine_required'))));
        }
        return (react_1.default.createElement("div", { className: "znd-shop-product-page__machine-selection mb-5" }, MachineStore_1.default.cutters?.map((massiveMachine) => (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.topCenter, label: (0, translation_1.t)('product_page.machine_has_already_been_licensed'), hidden: true == massiveMachine?.shopSoftwareOrderEnabled, key: massiveMachine.id, className: "znd-shop-product-page__machine-selection-item" },
            react_1.default.createElement("label", { className: "custom-control custom-checkbox" },
                react_1.default.createElement("input", { type: "checkbox", value: massiveMachine.id, checked: this.props.selected.includes(massiveMachine.id), className: "custom-control-input", disabled: true !== massiveMachine?.shopSoftwareOrderEnabled, onChange: (event) => this.props.onChange(event.target.value) }),
                react_1.default.createElement("span", { className: (0, classnames_1.default)('custom-control-label', {
                        'text-muted': true !== massiveMachine?.shopSoftwareOrderEnabled,
                    }) }, massiveMachine.externalId)))))));
    }
}
exports.default = (0, mobx_react_1.observer)(ShopProductMachineSelection);
